
import { useState } from 'react';

export const useSignatureAndStamp = () => {
  const [signature, setSignature] = useState<{ data: string; type: 'draw' | 'upload' } | null>(null);
  const [stamp, setStamp] = useState<string | null>(null);
  
  const handleSignatureSave = (signatureData: string, type: 'draw' | 'upload') => {
    setSignature({ data: signatureData, type });
    // For debugging
    console.log("Signature saved:", type, signatureData.substring(0, 100) + "...");
  };

  const handleStampUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          setStamp(reader.result);
          // For debugging
          console.log("Stamp saved:", reader.result.substring(0, 100) + "...");
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleStampRemove = () => {
    setStamp(null);
  };

  return {
    signature,
    stamp,
    handleSignatureSave,
    handleStampUpload,
    handleStampRemove
  };
};
